import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Alert } from 'react-bootstrap';
import { Contacts, TitleWMutedRow } from '../../../../sitel/demon/ui/atoms';
import { InputTextSingleColumn } from '../../../../sitel/demon/ui/form';

import schema from './formSchema';
import useFormSubmit from './useFormSubmit';
import { useState } from 'react';
import SubmitButton from '../../../../sitel/demon/ui/atoms/buttons/SubmitButton';

export default function Step1CreateRequest() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({ resolver: yupResolver(schema()) });
  const [emailSent, setEmailSent] = useState('not-sent');
  const [email, setEmail] = useState('');
  const onSubmit = useFormSubmit(setEmailSent, setEmail);

  return (
    <>
      <TitleWMutedRow muted='Make sure to use the same email you created your account with to reset your password'>Reset password</TitleWMutedRow>

      {emailSent === 'sent' && (
        <Alert variant='success'>
          <div className='m-0'>
            An email with instructions was sent to <strong>{email}</strong>.
            <hr />
            Please check your inbox and follow the instructions in the email.
          </div>
        </Alert>
      )}
      {emailSent === 'fail' && (
        <Alert variant='danger'>
          <p className='m-0'>An issue has occured.</p>
          <p> Please make sure to use the correct username/email.</p>
          <div className='m-0'>
            Please try again in few minutes.
            <hr />
            If issue repeats, <br />
            <Contacts.SitelHelpDeskLanguage />.
          </div>
        </Alert>
      )}
      {emailSent !== 'sent' && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <InputTextSingleColumn labelText='Username' id='username' placeholder='@gmail.com @yahoo.com @hotmail.com etc' maxlength='32' register={register} errors={errors} showIsRequired />
          <div className='form-group'>
          <SubmitButton defaultLabel="Request Password Reset" isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful && !(emailSent === 'fail')} className="btn-medstar-primary w-100 mt-3"/>
          </div>
        </form>
      )}
    </>
  );
}
